import Vue from 'vue';
export const OrderLayoutEvent = new Vue();



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/order-layout/order-layout-bus.js